// extracted by mini-css-extract-plugin
module.exports = {"PropertyTags":"PropertyTags_PropertyTags__2eRDP","platform":"PropertyTags_platform__1cH4R"};